import { useNavigate } from 'react-router-dom';
import { useTheme } from '@/context/ThemeContext';
import { Button } from '@/components/ui/button';
import {
  GraduationCap,
  Shield,
  ShoppingCart,
  Moon,
  Sun,
  History,
  LogOut
} from 'lucide-react';

const DashboardHeader = ({ user, onLogout }) => {
  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-slate-200/50 dark:border-slate-800/50 bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div 
            className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
            onClick={() => navigate('/')}
            title="Back to Home"
          >
            <div className="w-10 h-10 rounded-lg bg-[#0047AB] flex items-center justify-center">
              <GraduationCap className="w-6 h-6 text-white" />
            </div>
            <span className="font-bold text-xl tracking-tight">Exam Trainer</span>
          </div>
          
          <div className="flex items-center gap-2">
            {user?.role === 'admin' && (
              <Button 
                variant="outline" 
                onClick={() => navigate('/admin')} 
                className="rounded-full border-[#0047AB] text-[#0047AB] hover:bg-[#0047AB] hover:text-white" 
                data-testid="admin-btn"
              >
                <Shield className="h-4 w-4 mr-2" />
                Admin
              </Button>
            )}
            
            <Button 
              variant="outline" 
              onClick={() => navigate('/store')} 
              className="rounded-full" 
              data-testid="store-btn"
            >
              <ShoppingCart className="h-4 w-4 mr-2" />
              Store
            </Button>
            
            <Button variant="ghost" size="icon" onClick={toggleTheme} className="rounded-full" data-testid="theme-toggle">
              {theme === 'dark' ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
            </Button>
            
            <Button variant="ghost" size="icon" onClick={() => navigate('/history')} className="rounded-full" data-testid="history-btn">
              <History className="h-5 w-5" />
            </Button>
            
            <Button variant="ghost" size="icon" onClick={onLogout} className="rounded-full" data-testid="logout-btn">
              <LogOut className="h-5 w-5" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
